const e = "_sidebarMoveInRight_uar5g_1", r = "_sidebarMoveInLeft_uar5g_5", t = "_sideDrawer_uar5g_9", a = "_sideDrawerStacked_uar5g_15", o = "_outSideDrawer_uar5g_22", d = "_hiddenOutSide_uar5g_28", i = "_drawerHeader_uar5g_32", _ = "_drawerHeaderDescription_uar5g_36", n = "_contentContainer_uar5g_40", s = "_drawerFooter_uar5g_44", u = "_drawerActions_uar5g_51", c = "_mainFooterActions_uar5g_55", w = "_footerFullWidth_uar5g_59", g = "_footer3rdActions_uar5g_66", f = "_sideDrawerOutSideFadeOut_uar5g_70", D = "_sideDrawerMoveOut_uar5g_74", v = "_outSide_uar5g_22", S = {
  sidebarMoveInRight: e,
  "sidebar-move-in-right": "_sidebar-move-in-right_uar5g_1",
  sidebarMoveInLeft: r,
  "sidebar-move-in-left": "_sidebar-move-in-left_uar5g_1",
  sideDrawer: t,
  sideDrawerStacked: a,
  outSideDrawer: o,
  "drawer-fade-in": "_drawer-fade-in_uar5g_1",
  hiddenOutSide: d,
  drawerHeader: i,
  drawerHeaderDescription: _,
  contentContainer: n,
  drawerFooter: s,
  drawerActions: u,
  mainFooterActions: c,
  footerFullWidth: w,
  footer3rdActions: g,
  sideDrawerOutSideFadeOut: f,
  "drawer-fade-out": "_drawer-fade-out_uar5g_1",
  sideDrawerMoveOut: D,
  "sidebar-move-out-right": "_sidebar-move-out-right_uar5g_1",
  "sidebar-move-out-left": "_sidebar-move-out-left_uar5g_1",
  outSide: v
};
export {
  n as contentContainer,
  S as default,
  u as drawerActions,
  s as drawerFooter,
  i as drawerHeader,
  _ as drawerHeaderDescription,
  g as footer3rdActions,
  w as footerFullWidth,
  d as hiddenOutSide,
  c as mainFooterActions,
  v as outSide,
  o as outSideDrawer,
  t as sideDrawer,
  D as sideDrawerMoveOut,
  f as sideDrawerOutSideFadeOut,
  a as sideDrawerStacked,
  r as sidebarMoveInLeft,
  e as sidebarMoveInRight
};
//# sourceMappingURL=SideDrawer.module.scss.js.map
